import Marquee from "react-fast-marquee";
import { Sparkle } from "lucide-react";

const ITEMS = [
  "Your Story",
  "Your Gift",
  "Your Way",
  "Thoughtful Gifts",
  "Beautiful Memories",
];

export default function EditorialMarquee({ items }) {
  const list = items?.length ? items : ITEMS;
  return (
    <section
      data-testid="editorial-marquee"
      aria-hidden
      className="overflow-hidden border-y border-line bg-[#FDFBF9] py-7"
    >
      <Marquee speed={25} gradient={false} pauseOnHover>
        {list.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-16">
            <span className="whitespace-nowrap font-serif text-2xl italic text-rose md:text-4xl">
              {item}
            </span>
            <Sparkle size={18} className="fill-gold/40 text-gold" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
